import { Definition, DefinitionLabel, DefinitionValue } from '@cargomart/ui'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

interface ProfileInfoProps {
  email?: string
  isLoading?: boolean
  name?: string
  phone?: string
}

const LoadingInfo = () => (
  <Definition labelClassName="!text-body-md !py-1" valueClassName="!py-1">
    <DefinitionLabel>ФИО</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={2} />
    </DefinitionValue>
    <DefinitionLabel>Телефон</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={1} />
    </DefinitionValue>
    <DefinitionLabel>Электронная почта</DefinitionLabel>
    <DefinitionValue>
      <PlaceholderCell height={20} seed={1} />
    </DefinitionValue>
  </Definition>
)

export const ProfileInfo = ({ email, name, phone, isLoading = true }: ProfileInfoProps) => (
  <div className="mt-6 grid grid-cols-1 gap-x-4 pb-5 md:grid-cols-[160px,auto]">
    {isLoading ? (
      <LoadingInfo />
    ) : (
      <Definition labelClassName="!text-body-md !py-1" valueClassName="!py-1">
        <DefinitionLabel>ФИО</DefinitionLabel>
        <DefinitionValue data-test-id="profile-settings--full-name">{name || '—'}</DefinitionValue>
        <DefinitionLabel>Телефон</DefinitionLabel>
        <DefinitionValue data-test-id="profile-settings--phone">{phone || '—'}</DefinitionValue>
        <DefinitionLabel>Электронная почта</DefinitionLabel>
        <DefinitionValue data-test-id="profile-settings--email">
          {email ? (
            <a className="link cursor-pointer" href={`mailto:${email}`}>
              {email}
            </a>
          ) : (
            '—'
          )}
        </DefinitionValue>
      </Definition>
    )}
  </div>
)
